import DeviceTargeting from './device-targeting';

export default DeviceTargeting;
